import * as types from '../mutation-types'
import productsRepository from '../../api/productsRepository'

const state = {
    productToCreate: {},
    products: [],
    product: {},
    isProductCreated: false,
    isProductUpdated: false,
    isProductDeleted: false,
    productToUpdate: {},
    categoryCodes: [],
    areProductsImported: false
}

const getters = {
    productToCreate: state => state.productToCreate,
    products: state => state.products,
    product: state => state.product,
    isProductCreated: state => state.isProductCreated,
    isProductUpdated: state => state.isProductUpdated,
    isProductDeleted: state => state.isProductDeleted,
    productToUpdate: state => state.productToUpdate,
    categoryCodes: state => state.categoryCodes,
    areProductsImported: state => state.areProductsImported
}

const actions = {
    getProductsByCategory({ commit }, categoryId) {
        return productsRepository.getProductsByCategory(categoryId).then((response) => {
            commit(types.SET_PRODUCTS, response.data)
        })
    },
    searchAllProducts({ commit }, input) {
        return productsRepository.getProductsByInput(input).then((response) => {
            commit(types.SET_PRODUCTS, response.data[0])
        })
    },
    getProduct({ commit }, productId) {
        return productsRepository.getProduct(productId).then((response) => {
            commit(types.SET_PRODUCT, response.data)
        })
    },
    getCategoryCodes({ commit }) {
        return productsRepository.getCategoryCodes().then((response) => {
            commit(types.SET_CATEGORY_CODES, response.data[0])
        })
    },
    createProduct({ commit }) {
        return productsRepository.createProduct(state.productToCreate).then((response) => {
            if (response.data.success) {
                commit(types.SET_PRODUCT_CREATED, true)
                commit(types.ADD_PRODUCT_TO_PRODUCTS, response.data.message)
            } else {
                commit(types.SET_PRODUCT_CREATED, false)
            }
        })
    },
    editProduct({ commit }) {
        return productsRepository.editProduct(state.productToUpdate).then((response) => {
            if (response.data.success) {
                commit(types.EDIT_PRODUCT_IN_LIST, response.data.message)
                commit(types.SET_PRODUCT_UPDATED, true)
            } else {
                commit(types.SET_PRODUCT_UPDATED, false)
            }
        })
    },
    deleteProduct({ commit }, productId) {
        return productsRepository.deleteProduct(productId).then((response) => {
            if (response.data.success) {
                commit(types.SET_PRODUCT_DELETED, true)
            } else {
                commit(types.SET_PRODUCT_DELETED, false)
            }
        })
    },
    toggleProductActivation({ commit }) {
        return productsRepository.toggleProductActivation(state.productToUpdate).then((response) => {
            if (response.data.success) {
                commit(types.SET_PRODUCT_UPDATED, true)
            } else {
                commit(types.SET_PRODUCT_UPDATED, false)
            }
        })
    },
    importProducts({ commit }, products) {
        return productsRepository.importProducts(products).then((response) => {
            if (response.data.success) {
                commit(types.SET_PRODUCTS_IMPORTED, true)
            } else {
                commit(types.SET_PRODUCTS_IMPORTED, false)
            }
        })
    },
    toggleProductStar({ commit }) {
        return productsRepository.toggleProductStar(state.productToUpdate).then((response) => {
            if (response.data.success) {
                commit(types.SET_PRODUCT_UPDATED, true)
            } else {
                commit(types.SET_PRODUCT_UPDATED, false)
            }
        })
    },
    getStarProduct({ commit }) {
        return productsRepository.getStarProduct().then((response) => {
            commit(types.SET_PRODUCTS, response.data[0])
        })
    },
    toggleProductOffer({ commit }) {
        return productsRepository.toggleProductOffer(state.productToUpdate).then((response) => {
            if (response.data.success) {
                commit(types.SET_PRODUCT_UPDATED, true)
            } else {
                commit(types.SET_PRODUCT_UPDATED, false)
            }
        })
    },
    getOfferProducts({ commit }) {
        return productsRepository.getOfferProducts().then((response) => {
            commit(types.SET_PRODUCTS, response.data[0])
        })
    }
}

const mutations = {
    [types.SET_PRODUCT_TO_CREATE](state, payload) {
        state.productToCreate = payload
    },
    [types.SET_PRODUCT_TO_UPDATE](state, payload) {
        state.productToUpdate = payload
    },
    [types.SET_PRODUCTS](state, payload) {
        state.products = payload
    },
    [types.SET_PRODUCT](state, payload) {
        state.product = payload
    },
    [types.SET_CATEGORY_NAME_ON_PRODUCT](state, payload) {
        state.product.categoryName = payload
    },
    [types.SET_CATEGORY_ID_ON_PRODUCT](state, payload) {
        state.product.categoryId = payload
    },
    [types.SET_PRODUCT_CREATED](state, payload) {
        state.isProductCreated = payload
    },
    [types.SET_PRODUCT_UPDATED](state, payload) {
        state.isProductUpdated = payload
    },
    [types.SET_PRODUCT_DELETED](state, payload) {
        state.isProductDeleted = payload
    },
    [types.ADD_PRODUCT_TO_PRODUCTS](state, payload) {
        state.products.push(payload)
    },
    [types.REMOVE_PRODUCT_FROM_PRODUCTS](state, payload) {
        state.products.forEach((product, index) => {
            if (product.id === payload) {
                state.products.splice(index, 1)
            }
        })
    },
    [types.SET_CATEGORY_CODES](state, payload) {
        state.categoryCodes = payload
    },
    [types.EDIT_PRODUCT_IN_LIST](state, payload) {
        state.products.forEach((product, index) => {
            if (product.id === payload.id) {
                state.products.splice(index, 1)
                state.products.push(payload)
            }
        })
    },
    [types.ADD_DISCOUNTS_TO_PRODUCTS](state, discounts) {
        let products = state.products
        state.products = []
        products.forEach((product) => {
            let discountApplied = false
            discounts.forEach((discount) => {
                if (product.categoryCode === discount.code) {
                    if (discount.active) {
                        product.discount = discount.discount
                    } else {
                        product.discount = 0
                    }
                    discountApplied = true
                    state.products.push(product)
                }
            })
            if (!discountApplied) {
                product.discount = 0
                state.products.push(product)
            }
        })
    },
    [types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS](state, prices) {
        let products = state.products
        state.products = []
        products.forEach((product) => {
            let priceApplied = false
            prices.forEach((price) => {
                if (product.articleNumber === price.articleNumber) {
                    product.price = price.price
                    product.customPrice = true
                    product.discount = 0
                    priceApplied = true
                    state.products.push(product)
                }
            })
            if (!priceApplied) {
                state.products.push(product)
            }
        })
    },
    [types.SET_PRODUCTS_IMPORTED](state, payload) {
        state.areProductsImported = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
